import { SmileFill, SmileOutline } from 'antd-mobile-icons';
import { Button, DatePicker, Radio, Space, Toast } from 'antd-mobile-v5';
import { getAllMaterial, getMaterialDetail } from "apis/material";
import { navigateTo } from 'common/util';
import MaterialInfoCard from "components/MaterialInfoCard";
import StepBar from 'components/StepBar';
import qs from "qs";
import React, { Component } from "react";
import CountdownModal from '../home/coundownModal';
import Finish from "./finish";
import './index.less';
import Leave from './leave';
import Queue from './queue';
import Sign from './sign';

const mtl = window.mtl || {};

export default class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            materialData: null,
            count: 0,
            currentStatusCode: null,
            status: true,
            longitude: null,
            latitude: null,
            yystate: 0,
            yyButtonDisable: true,
            yyButton1Disable: true,
            yyradiovalue: '',
            yyDate: '请选择要预约的时间',
            canNotyy: false,
            yydateVis: false,
            yydata: [],
            yydatas: [],
            payDates: [],
            picconf: "",
            stepData: [

                {
                    title: '预约',
                    iconName: "iconProcess",
                    description: ''
                },
                {
                    title: '签到',
                    iconName: "iconWait",
                    description: ''
                },
                {
                    title: '排队',
                    iconName: "iconWait",
                    description: ''
                },
                {
                    title: '出厂',
                    iconName: "iconWait",
                    description: ''
                }
            ],
            // 预约天数
            dateofdelievy: 0
        }
    }

    componentDidMount() {
        this.getDetailInfo();
        let html = document.querySelector("html");
        html.style.background = "#FFFFFF";
    }
    //查询可预约日期
    getYYDate = (materialInfo) => {
        let params = this.props.location.search.replace(/^\?/, '') || window.location.search.replace(/^\?/, '');;
        const { stockorgId, deliveryId } = qs.parse(params);
        const { deliveryBodys } = materialInfo;
        const { material } = deliveryBodys[0];
        const { pk_material } = material;
        let paramData = {
            action: "5",
            appid: "",
            param: {
                pk_delivery: deliveryId,
                pk_stockorg: stockorgId,
                pk_org: stockorgId,
                VDEF6: "",
                pk_material: pk_material
            }
        }
        let result = getAllMaterial(paramData);
        result.then(res => {
            if (res) {
                if (res.statuscode === '0') {
                    var datas = Object.keys(res.datas);
                    let dateofdelievy = res.datas.result;
                    datas.splice(datas.indexOf("result"), 1);
                    if (datas.length == 0) {
                        datas = ["0"]
                        this.setState({
                            yyDate: '没有可预约的号',
                            canNotyy: true
                        })
                    } else {
                        this.setState({
                            yydatas: res.datas,
                            payDates: datas,
                            dateofdelievy,
                            yyDate: '请选择要预约的时间',
                            canNotyy: false
                        }, function () {
                            this.renderYy();
                        })
                    }
                } else {
                    Toast.fail("查询预约失败：" + res.errinfo, 5);
                }
            }
        });

    }
    //获取详情页信息
    getDetailInfo = () => {
        let params = this.props.location.search.replace(/^\?/, '') || window.location.search.replace(/^\?/, '');
        const { stockorgId, deliveryId } = qs.parse(params);
        document.title = "派车单详情";
        let param = {
            action: "2",
            appid: "",
            param: {
                pk_delivery: deliveryId,
                pk_stockorg: stockorgId
            }
        };
        let result = getMaterialDetail(param);
        result.then(res => {
            if (res) {
                let materialInfo = res.datas;
                this.setState({
                    materialData: materialInfo,
                    currentStatusCode: materialInfo?.lineStatus?.code,
                });
                this.changeStep(materialInfo?.lineStatus, materialInfo?.fstatusflag?.code);
                let yyFlag = materialInfo?.lineStatus?.code;
                let billstatus_unused = materialInfo?.fstatusflag?.code;
                // 未预约并且未作废的单据需要查询预约数
                if (yyFlag && yyFlag < 0 && billstatus_unused && billstatus_unused == -1) {
                    this.getYYDate(materialInfo);
                }
            }
        })

        this.getLocation();
    }

    // 获取当前的一个位置信息
    getLocation = () => {
        mtl.getLocation({
            type: 'gcj02',//默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: res => {
                let latitude = res.latitude;//纬度，浮点数，范围为90~-90
                let longitude = res.longitude;//经度，浮点数，范围为180~-180。
                this.setState({
                    latitude,
                    longitude
                })
            },
            fail(err) {
                console.log(err,'获取位置信息失败');
            }
        });
    }

    // 处理进度条的一个变化
    changeStep = (lineStatus, invalidCode) => {
        let { stepData } = this.state;
        const { code, signTime, queueTime, finishTime } = lineStatus;
        let count;
        stepData = stepData.map((item, index) => {
            if (invalidCode === 1) {
                index === 0 && (item.iconName = 'iconWait');
                this.setState({
                    status: false
                })
            } else {
                switch (code) {
                    case "-1":
                        this.setState({
                            yystate: 0
                        })
                        count = 0;
                        index === 0 && (item.iconName = 'iconProcess');
                        index === 1 && (item.iconName = 'iconWait');
                        break;
                    case "0":
                        count = 1;
                        index === 0 && (item.iconName = 'iconFinshed');
                        index === 1 && (item.iconName = 'iconProcess');
                        break;
                    case "1":
                        count = 2;
                        index === 0 && (item.iconName = 'iconFinshed');
                        index === 1 && (item.iconName = 'iconFinshed', item.description = signTime);
                        index === 2 && (item.iconName = 'iconProcess');
                        break;
                    case "2":
                        count = 3;
                        index === 0 && (item.iconName = 'iconFinshed');
                        index === 1 && (item.iconName = 'iconFinshed', item.description = signTime);
                        index === 2 && (item.iconName = 'iconFinshed', item.description = queueTime);
                        index === 3 && (item.iconName = 'iconProcess');
                        break;
                    case "3":
                        count = 4;
                        item.iconName = 'iconFinshed'
                        index === 1 && (item.description = signTime);
                        index === 2 && (item.description = queueTime);
                        index === 3 && (item.description = finishTime);
                        break;
                    default:
                        break;
                }
            }
            return item
        })
        this.setState({
            count,
            stepData,
            currentStatusCode: code,
        })

    }

    // 处理签到完成以后步骤条的改变以及数据的刷新
    handleStateInfo = data => {
        this.setState({
            materialData: data
        })
        this.changeStep(data.lineStatus, data.fstatusflag.code);
    }

    // 刷新位置信息
    refreshLocation = data => {
        console.log(data,'data')
        if (data) {
            this.getLocation();
        }
    }

    // 刷新排队信息
    refreshQueue = data => {
        if (data) {
            this.getDetailInfo();
        }
    }

    // 跳转到入场须知页面
    openAdmission = (data) => {
        let getUrl = currentPage => {
            currentPage = currentPage || ''
            return `/admission${currentPage}?pkId=${data}`
        }
        navigateTo({
            path: getUrl(),
            url: `/pages${getUrl('/index')}`,
        })
    }

    getPK = (materialData) => {
        let type = materialData?.vbilltypecode;
        let pkAddress;
        if (type === "4EAB") {
            // 说明这是提货单，需要拿的数据在表体里面的每个数组的sendUnit中的pk;
            pkAddress = materialData?.deliveryBodys[0]?.vsendaddress?.pk_address_b;
        } else if (type === "4EAC") {
            pkAddress = materialData?.deliveryBodys[0]?.vreceiveaddress?.pk_address_b;
        }
        return pkAddress;
    }

    renderYy = () => {
        let params = this.props.location.search.replace(/^\?/, '') || window.location.search.replace(/^\?/, '');;
        const { yystate, yydateVis, yyDate, yyButtonDisable, yydata, yyradiovalue, yyButton1Disable, materialData, yydatas } = this.state;
        const { deliveryBodys } = materialData;
        const { material } = deliveryBodys[0];
        const { pk_material } = material;
        const dateFilter = {
            year: (val, { date }) => {
                var date1 = new Date();
                var date2 = new Date();
                let dateofdelievy = this.state.dateofdelievy;
                date2.setDate(date1.getDate() + dateofdelievy - 1);
                if (date.getFullYear() == new Date().getFullYear() || date.getFullYear() == date2.getFullYear()) {
                    var payDates = this.state.payDates;
                    if (payDates.length > 0) {
                        var yearList = [];
                        for (var i = 0; i < payDates.length; i++) {
                            if (yearList.indexOf(payDates[i].substring(0, 4)) == -1) {
                                yearList.push(payDates[i].substring(0, 4));
                            }
                        }
                        if (yearList.indexOf(val.toString()) == -1) {
                            return false
                        }
                    }
                    return true
                }
                return false
            },
            month: (val, { date }) => {
                var date1 = new Date();
                var date2 = new Date();
                let dateofdelievy = this.state.dateofdelievy;
                date2.setDate(date1.getDate() + dateofdelievy - 1);
                if (date.getMonth() == new Date().getMonth() || date.getMonth() == date2.getMonth()) {
                    var payDates = this.state.payDates;
                    if (payDates.length > 0) {
                        var monthList = [];
                        for (var i = 0; i < payDates.length; i++) {
                            if (monthList.indexOf(payDates[i].substring(5, 7)) == -1) {
                                monthList.push(payDates[i].substring(5, 7));
                            }
                        }
                        var thival = val.toString();
                        if (val < 10) {
                            thival = "0" + thival;
                        }
                        if (monthList.indexOf(thival) == -1) {
                            return false
                        }
                    }
                    if (date2.getMonth() != 0) {
                        return true
                    } else if (date.getFullYear() == date2.getFullYear() && date.getMonth() == date2.getMonth()) {
                        return true
                    } else if (date.getFullYear() + 1 == date2.getFullYear() && date.getMonth() == new Date().getMonth()) {
                        return true
                    } else {
                        return false
                    }
                }
                return false
            },
            day: (val, { date }) => {
                var date1 = new Date();
                var diffDate = Date.parse(date) - Date.parse(date1);
                var totalDays = Math.floor(diffDate / (1000 * 3600 * 24));
                var dateofdelievy = this.state.dateofdelievy;
                if (totalDays + 1 < dateofdelievy && totalDays + 1 >= 0) {
                    var payDates = this.state.payDates;
                    if (payDates.length > 0) {
                        var dayList = [];
                        for (var i = 0; i < payDates.length; i++) {
                            if (dayList.indexOf(payDates[i].substring(8, 10)) == -1) {
                                dayList.push(payDates[i].substring(8, 10));
                            }
                        }
                        var thival = val.toString();
                        if (val < 10) {
                            thival = "0" + thival;
                        }
                        if (dayList.indexOf(thival) == -1) {
                            return false
                        }
                    }
                    return true
                }
                return false
            }
        }
        const { stockorgId, deliveryId } = qs.parse(params);
        if (yystate === 0) {
            return (
                <>
                    <Button
                        style={{ marginTop: 20 }}
                        // shape='rounded'
                        // color='danger'
                        block='true'
                        onClick={() => {
                            let { canNotyy } = this.state;
                            if (canNotyy) {
                                return false;
                            }
                            this.setState({
                                yydateVis: true
                            })
                        }}
                    >
                        {yyDate}
                    </Button>
                    <DatePicker
                        title='选择预约时间'
                        visible={yydateVis}
                        mode='date'
                        filter={
                            dateFilter
                        }
                        onClose={() => {
                            this.setState({
                                yydateVis: false
                            })
                        }}

                        onConfirm={val => {
                            var Month = val.getMonth() + 1;
                            if (Month < 10) {
                                Month = '0' + Month;
                            }
                            var Date = val.getDate();
                            if (Date < 10) {
                                Date = '0' + Date;
                            }
                            var str = val.getFullYear() + "-" + Month + "-" + Date;

                            this.setState({
                                yydateVis: false,
                                yyDate: str,
                                yyButtonDisable: false
                            })
                        }}
                    />
                    <Button
                        shape='rounded' color='primary'
                        disabled={yyButtonDisable}
                        style={{ marginTop: 20, marginLeft: '37%' }}
                        onClick={() => {
                            this.setState({
                                yystate: 1,
                                yydata: yydatas[yyDate]
                            })
                        }}
                    >
                        预约查询</Button>
                </>
            );
        } else if (yystate === 1) {
            return (
                <>
                    <Radio.Group
                        value={yyradiovalue}
                        onChange={val => {
                            this.setState({
                                yyradiovalue: val,
                                yyButton1Disable: false
                            })
                        }}
                    >
                        <Space direction='vertical'>
                            {
                                yydata.map((item, value) => {
                                    return <Radio
                                        value={item.pk}
                                        icon={checked =>
                                            checked ? (
                                                <SmileFill style={{ color: 'var(--adm-color-primary)' }} />
                                            ) : (
                                                <SmileOutline style={{ color: 'var(--adm-color-weak)' }} />
                                            )
                                        }
                                    >
                                        {item.name + "   " + item.start + "-" + item.end + "   剩余可预约数：" + item.count}
                                    </Radio>
                                })
                            }
                        </Space>
                    </Radio.Group>

                    <Button

                        shape='rounded' color='primary'
                        disabled={yyButton1Disable}
                        style={{ marginTop: 20, marginLeft: '37%' }}
                        onClick={() => {
                            let paramData = {
                                action: "6",
                                appid: "",
                                param: {
                                    pk_stockorg: stockorgId,
                                    pk_org: stockorgId,
                                    VDEF6: yyDate,
                                    pk_thd: deliveryId,
                                    yysjd: yyradiovalue
                                }
                            }
                            let result = getAllMaterial(paramData);
                            result.then(res => {
                                if (res.statuscode === '0') {
                                    Toast.show(res.datas.message);
                                    this.setState({
                                        picconf: res.datas.picconf
                                    })
                                    this.getDetailInfo();
                                }
                            });
                        }}
                    >
                        预约</Button>

                </>
            )
        } else {

        }

    }

    render() {
        const { materialData, count, stepData, currentStatusCode, status, longitude, latitude, picconf } = this.state;
        let pk_delivery = materialData?.pk_delivery;
        let pk_org = materialData?.stockorg?.pk_org;

        let pk = this.getPK(materialData);

        let showIcon = currentStatusCode === "1" || currentStatusCode === "2" ? "block" : "none";
        let carrierStyle = currentStatusCode === "1" || currentStatusCode === "2" ? "body-carrier" : "body-carrier-longer"




        let showDetail;
        if (materialData?.fstatusflag?.code === 1) {
            showDetail = <div></div>;
        } else {
            switch (currentStatusCode) {
                case "-1":
                    showDetail = this.renderYy();
                    break;
                case "0":
                    showDetail = <Sign getDetailInfo={this.getDetailInfo} getAllMaterial={getAllMaterial} getCurrentSignInfo={this.handleStateInfo} getLocationRefresh={this.refreshLocation} picconf={picconf} pkDelivery={pk_delivery} pkOrg={pk_org} materialData={materialData} longitude={longitude} latitude={latitude}></Sign>;
                    break;
                case "1":
                    showDetail = <Queue getQueueRefresh={this.refreshQueue} materialData={materialData}></Queue>;
                    break;
                case "2":
                    showDetail = <Leave pkDelivery={pk_delivery}></Leave>;
                    break;
                case "3":
                    showDetail = <Finish pkDelivery={pk_delivery} pkOrg={pk_org} ></Finish>;
                    break;
                default:
                    break;
            }
        }

        return (
            <div>
                <div className="detail-page-top">
                    <div></div>
                    <div className="detail-page-top-card">
                        <MaterialInfoCard
                            {...this.props}
                            data={materialData}
                            longitude={longitude}
                            latitude={latitude}
                        >
                        </MaterialInfoCard>
                    </div>
                </div>
                <div className="detail-page-body">
                    <div>
                        <div className={carrierStyle}>{materialData?.stockorg?.name}</div>
                        <div className="body-admission" style={{ display: showIcon }} onClick={() => this.openAdmission(pk)}></div>
                    </div>
                    <div className="body-steps">
                        <StepBar count={count} stepData={stepData} status={status}></StepBar>
                    </div>
                    {showDetail}
                </div>
                {
                    this.state.materialData?.pk_delivery && this.state.materialData.vprocessstatus < 40 ? <CountdownModal info={this.state.materialData?.admissionnotice} /> : null
                }

            </div>
        );
    }
}
